import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import PostAd from './pages/PostAd';
import EditAd from './pages/EditAd';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import AdsPage from './pages/AdsPage';
import AdDetails from './pages/AdDetails';
import VendorProfile from './pages/VendorProfile';
import AdminDashboard from './pages/AdminDashboard';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import { analytics } from './firebase/config';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Spinner from './components/Spinner';
import GlobalFAB from './components/GlobalFAB';

const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Spinner fullPage message="Authenticating..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Spinner fullPage message="Authenticating..." />;
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {

  useEffect(() => {
    // Log a page_view event or similar if needed
    console.log("App initialized with Firebase:", analytics);
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <ThemeProvider>
          <Router>
            <ScrollToTop />
            <div className="app-layout" style={{ backgroundColor: 'var(--color-background-main)', color: 'var(--color-text-primary)' }}>
              <Header />
              <main style={{ minHeight: '80vh' }}>
                <Routes>

                  <Route path="/" element={<Home />} />

                  <Route path="/buy" element={<AdsPage type="buy" />} />
                  <Route path="/rent" element={<AdsPage type="rent" />} />
                  <Route path="/parts" element={<AdsPage type="parts" />} />
                  <Route path="/service-stations" element={<AdsPage type="service" />} />
                  <Route path="/ad/:id" element={<AdDetails />} />

                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsAndConditions />} />

                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />

                  <Route
                    path="/profile"
                    element={
                      <RequireAuth>
                        <Profile />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/post-ad"
                    element={
                      <RequireAuth>
                        <PostAd />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/edit-ad/:id"
                    element={
                      <RequireAuth>
                        <EditAd />
                      </RequireAuth>
                    }
                  />

                  <Route
                    path="/admin"
                    element={
                      <AdminRoute>
                        <AdminDashboard />
                      </AdminRoute>
                    }
                  />

                  {/* Catch-all for Vendor/Ad custom slugs */}
                  <Route path="/:slug" element={<VendorProfile />} />
                  <Route path="/:vendorSlug/:adSlug" element={<AdDetails />} />
                </Routes>
              </main>
              <GlobalFAB />
              <Footer />
            </div>
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
